import axios from "../axiosClient";

export const getSiteSummary = async (
  tcCode: any,
  siteCode: any,
  signal: any,
) => {
  const res = await axios.get(`/slpapp/TC/getLocationBlockSummary`, {
    params: { tcCode, siteCode },
    signal,
  });

  return res?.data?.data;
};

export const getEquipmentQuantityByCode = async (
  tcCode: any,
  siteCode: any,
  blockCode: any,
  signal: any,
) => {
  const res = await axios.get(`/slpapp/Dashboard/getEquipmentQuantityByCode`, {
    params: { tcCode, siteCode, blockCode },
    signal,
  });

  return res?.data?.data;
};

export const getHealthStatusByLocationOrAssetCode = async (
  tcCode: any = null,
  siteCode: any = null,
  blockCode: any = null,
  assetCode: any = null,
  signal?: any,
) => {
  return await axios.get(`/slpapp/Dashboard/getHealthStatusByLocationOrAsset`, {
    params: { tcCode, siteCode, blockCode, assetCode },
    signal,
  });
};

export const getAllBlocksByCode = async (siteCode: any, signal: any) => {
  const res = await axios.get(`/slpapp/Dashboard/getAllBlocksByCode`, {
    params: { siteCode },
    signal,
  });

  return res?.data?.data;
};

export const getAllSitesByCode = async (
  tcCode: any,
  faultType: any,
  signal: any,
) => {
  const res = await axios.get(`/slpapp/Site/allSiteLocation`, {
    params: { tcCode, faultType },
    signal,
  });

  return res?.data?.data;
};

export const getBlockWithFailures = async (
  failureType: any,
  pageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
) => {
  const payload = {
    failureType,
    pageNumber,
    pageSize,
    sortBy: SortBy,
    sortDirection: SortDirection,
  };

  const res = await axios.post(`/slpapp/Dashboard/BlockWithFailures`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res?.data;
};

export const getAssetsByLocationAndType = async (
  assetTypeId: any,
  pageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  tcCode?: any,
  siteCode?: any,
  blockCode?: any,
  searchText?: string | null,
) => {
  if (!assetTypeId) return;

  const payload = {
    assetTypeId,
    PageNumber: pageNumber,
    PageSize: pageSize,
    SortBy,
    SortDirection,
    tcCode,
    siteCode,
    blockCode,
    searchText: searchText || null,
  };

  const res = await axios.get(`/slpapp/Asset/AssetsByLocationAndType`, {
    params: payload,
  });

  return res?.data;
};

export const getGridData = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  tcCode: any = null,
  siteCode: any = null,
  signal?: any,
) => {
  const res = await axios.get(`/slpapp/Dashboard/getGridDataByCode`, {
    params: {
      PageNumber,
      pageSize,
      SortBy,
      SortDirection,
      tcCode,
      siteCode,
    },
    signal,
  });

  return res?.data;
};

export const getLightLocationDashboardSummary = async (
  tcCode: any,
  signal: any,
  siteCode?: any,
  blockCode?: any,
) => {
  const res = await axios.get(`/slpapp/TC/getLightLocationDashboardSummary`, {
    params: { tcCode, siteCode, blockCode },
    signal,
  });

  return res?.data?.data;
};

export const getLocationBlockSummary = async (tcCode: any, signal: any) => {
  const res = await axios.get(`/slpapp/TC/getLocationBlockSummary`, {
    params: { tcCode },
    signal,
  });

  return res?.data?.data;
};

export const getLocationGatewaySummary = async (tcCode: any, signal: any) => {
  const res = await axios.get(`/slpapp/TC/getLocationGatewaySummary`, {
    params: { tcCode },
    signal,
  });

  return res?.data?.data;
};

export const getLocationLightSummary = async (tcCode: any, signal: any) => {
  const res = await axios.get(`/slpapp/TC/getLocationLightSummary`, {
    params: { tcCode },
    signal,
  });

  return res?.data?.data;
};

export const getTCSummaryInfo = async (tcCode: any, signal: any) => {
  const res = await axios.get(`/slpapp/TC/getTCSummaryInfo`, {
    params: { tcCode },
    signal,
  });

  return res?.data?.data;
};

export const getEnergySavingsDashboardDataByTcCode = async (
  tcCode: any,
  signal: any,
) => {
  const res = await axios.get(
    `/slpapp/Dashboard/getEnergySavingsDashboardDataByTcCode`,
    {
      params: { tcCode },
      signal,
    },
  );

  const data = res?.data?.data[0];

  return data;
};

export const getEnergySavingsGraphDataByTcCode = async (
  tcCode: any,
  signal: any,
) => {
  const res = await axios.get(
    `/slpapp/Dashboard/getEnergySavingsGraphDataByTcCode`,
    {
      params: { tcCode },
      signal,
    },
  );

  const data = res?.data?.data;

  return data;
};

export const getHealthStatusByLocationOrAsset = async (
  tcCode: any = null,
  signal?: any,
  siteCode: any = null,
  blockCode: any = null,
  assetCode: any = null,
) => {
  const res = await axios.get(
    `/slpapp/Dashboard/getHealthStatusByLocationOrAsset`,
    {
      params: {
        tcCode,
        siteCode,
        blockCode,
        assetCode,
      },
      signal,
    },
  );

  const data = await res?.data?.data;

  return data;
};

export const getDatewiseFaultCountByTC = async (
  tcCode: any = null,
  signal?: any,
) => {
  const res = await axios.get(`/slpapp/Fault/getDatewiseFaultCountByTC`, {
    params: {
      tcCode,
    },
    signal,
  });

  const data = await res?.data?.data;

  return data;
};

export const getLastSixMonthsFaultTurnAroundTimeByTC = async (
  tcCode: any = null,
  signal?: any,
) => {
  const res = await axios.get(
    `/slpapp/Fault/getLastSixMonthsFaultTurnAroundTimeByTC`,
    {
      params: {
        tcCode,
      },
      signal,
    },
  );

  const data = await res?.data?.data;

  return data;
};

export const getTurnAroundTimeLastMonth = async (
  tcCode: any = null,
  signal?: any,
) => {
  const res = await axios.get(`/slpapp/Fault/getTurnAroundTimeLastMonth`, {
    params: {
      tcCode,
    },
    signal,
  });

  const data = await res?.data?.data[0];

  return data;
};
